export default {
	label: 'Reference | References',
	method: 'Method references',
	addMethod: 'Add method reference',
	addModule: 'Add module reference',
	placeholder: 'Enter URL...',
	module: 'Module references',
	title: 'Enter reference title...',
	missing: 'No references',
	risk: 'Risk references',
	threat: 'Threat references',
	vulnerability: 'Vulnerability references',
	add: 'Add reference',
	url: 'URL references',
	document: 'Document references',
	selectFile: 'Select a file',
	selectUrl: 'Select a URL',
}
